export default {
	"button": [
		{
			name: '点击',
			trigger: "click"
		},
		
	]
}


